export default __webpack_public_path__ + "static/media/backgroundimage.35741440.jpg";